document.addEventListener('DOMContentLoaded', function () {
    function isElementPartiallyInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    const container = document.querySelector('.brands-quotes-section__quotes');
    const logosContainer = document.querySelector('.brands-quotes-section__logos-container');
    const sectionContainer = document.querySelector('.brands-quotes-section');

    // WICHTIG: Alle Logos & Quotes holen
    let logos = Array.from(document.querySelectorAll('.brands-quotes-section__logo'));
    let quotes = Array.from(document.querySelectorAll('.brands-quotes-section__quote'));

    // Auf Mobil nur die ersten 4 verwenden
    const isMobile = window.innerWidth < 700;
    if (isMobile) {
        logos = logos.slice(0, 4);
        quotes = quotes.slice(0, 4);
    }

    let currentActiveIndex = 0;
    let isAnimating = false;

    // Nur die erste Quote sichtbar machen
    gsap.set(quotes[currentActiveIndex], { opacity: 1, y: '0%' });
    gsap.set(container, { height: quotes[currentActiveIndex].offsetHeight });

    function transitionToSlide(newIndex) {
        if (isAnimating || newIndex === currentActiveIndex) return;

        // Logo-Status aktualisieren
        logos[currentActiveIndex].classList.remove('brands-quotes-section__logo-active');
        logos[newIndex].classList.add('brands-quotes-section__logo-active');

        // Bild wechseln
        const currentLogoImg = logos[currentActiveIndex].querySelector('img');
        const newLogoImg = logos[newIndex].querySelector('img');
        currentLogoImg.src = logos[currentActiveIndex].dataset.logo;
        newLogoImg.src = logos[newIndex].dataset.activeLogo;

        // Nur scrollen, wenn Container sichtbar
if (logosContainer.scrollWidth > logosContainer.clientWidth) {
  logos[newIndex].scrollIntoView({
    behavior: 'smooth',
    inline: 'center',
    block: 'nearest',
  });
}

        isAnimating = true;
        const oldQuote = quotes[currentActiveIndex];
        const newQuote = quotes[newIndex];
        const newHeight = newQuote.offsetHeight;

        const tl = gsap.timeline({
            onComplete: function () {
                oldQuote.classList.remove('brands-quotes-section__quote-active');
                newQuote.classList.add('brands-quotes-section__quote-active');
                currentActiveIndex = newIndex;
                isAnimating = false;
            },
        });

        tl.to(container, {
            duration: 0.5,
            height: newHeight,
            ease: 'power1.out',
        }, 0);

        tl.to(oldQuote, {
            duration: 0.5,
            y: '-100%',
            opacity: 0,
            ease: 'power1.in',
        }, 0);

        tl.set(newQuote, { y: '100%', opacity: 0 }, 0.5);

        tl.to(newQuote, {
            duration: 0.5,
            y: '0%',
            opacity: 1,
            ease: 'power1.out',
        }, 0.5);
    }

    logos.forEach((logo, index) => {
        logo.addEventListener('click', function () {
            transitionToSlide(index);
        });
    });

    setInterval(function () {
        if (isElementPartiallyInViewport(sectionContainer)) {
            const nextIndex = (currentActiveIndex + 1) % quotes.length;
            transitionToSlide(nextIndex);
        }
    }, window.settingsAnimationTime * 1000);
});